// E2.9: after the event stream comes back, the UI re-reads durable server state instead of trusting what the
// JavaScript memory saw before the gap (events may have been missed; the cursor replay is best effort).
import type { StreamStatus } from "./sse.ts";

/** True when the stream just recovered from a gap (reconnecting/offline → live). The first connect is not a gap. */
export function recoveredFromGap(previous: StreamStatus, next: StreamStatus): boolean {
  return next === "live" && (previous === "reconnecting" || previous === "offline");
}
